import { t } from 'i18next'
import { DropdownItem } from '../model/dropdownItem.model'

export const apprenticeshipModuleTypes: DropdownItem[] = [
  {
    label: t<string>('grade_module.module.type.professional_module'),
    value: 1,
  },
  { label: t<string>('grade_module.module.type.school_subject'), value: 2 },
  { label: t<string>('grade_module.module.type.matura'), value: 4 },
  { label: t<string>('grade_module.module.type.uek'), value: 3 },
]